import React from 'react';
import {i18nData} from 'helpers/i18n';
import { Section } from 'spectacle-ppa';
import videoSlide from '../../baseSlides/videoSlide';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile_en from './mme.md';
import markdownFile_fr_CA from './mme.fr_CA.md';

const md = i18nData({
  en: new MarkdownScript(markdownFile_en),
  fr_CA: new MarkdownScript(markdownFile_fr_CA)
});

function mmeSection ({ level, regionData, i18n }) {
  const md_i18n = i18n(md);
  return (
    <Section id="mme">

      {/* MME segment */}
      {videoSlide({
        id: 'video',
        notes: md_i18n.getSubSectionAsHtml(`MME Level ${level}`, 'Notes', false, regionData),
        youTubeId: md_i18n.getSectionMetadata(`MME Level ${level}`, 'YouTube', regionData)
      })}

    </Section>
  );
}

export default mmeSection;



// WEBPACK FOOTER //
// ./programs/h2whoa/sections/13_mme/mmeSection.jsx